import { Currency } from '../../constants/currency';
import type { IAccumulativeDepositOffer } from '../../interfaces/offers';
import { getAmountRangeToString } from '../humanization';

export const getAccumulativeDepositConditions = (item: IAccumulativeDepositOffer) => {
  const { term, rate, amount } = item;

  const amountValue = getAmountRangeToString({ amountRange: amount, currency: Currency.RUB });

  return [
    rate && { value: `${rate}`, description: 'ставка в год' },
    amountValue && term && { value: amountValue, description: `на срок ${term}`, wide: true },
  ];
};
